import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store/store";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import DirectionProvider from "./provider/DirectionProvider";
import AppThemeProvider from "./provider/AppThemeProvider";
import DrawerProvider from "provider/DrawerProvider";
import { createRoot } from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import ErrorBoundary from "helpers/ErrorBoundary";
import reportWebVitals from "reportWebVitals";

const domNode = document.getElementById("root") as Element;
const root = createRoot(domNode);

root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <Provider store={store}>
        <DrawerProvider />
        <DirectionProvider>
          <AppThemeProvider>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </AppThemeProvider>
        </DirectionProvider>
      </Provider>
    </BrowserRouter>
  </ErrorBoundary>
);

serviceWorkerRegistration.register();
reportWebVitals();

